import React from 'react';
import { Route, Redirect, useLocation } from "react-router-dom";
import PropTypes from 'prop-types'
import { useAtom } from 'jotai'
import { isAuthAtom, userRoleAtom, dataUserAtom } from '../Services/store/atoms';

const CLIENT_COMPLETE_PROFILE_PATH = '/client/complete-profile'
const MODEL_COMPLETE_REGISTRATION_PATH = '/model/complete-registration'
const CHOOSE_ROLE_PATH = '/choose-role'

function RouteCheck({ ...props }) {
  const [isAuth] = useAtom(isAuthAtom)
  const [userRole] = useAtom(userRoleAtom)
  const [dataUser] = useAtom(dataUserAtom)
  const location = useLocation()

  if (props.type === 'private' && !isAuth) return <Redirect to={'/'} />

  // Cuenta creada por Google login sin rol (botón de /login): no puede usar
  // nada privado hasta elegir cliente/modelo, sin importar cómo llegó acá.
  if (
    props.type === 'private' &&
    isAuth &&
    !userRole &&
    location.pathname !== CHOOSE_ROLE_PATH
  ) {
    return <Redirect to={CHOOSE_ROLE_PATH} />
  }

  // Cliente autenticado sin gender/interested_in cargados: lo mandamos a
  // completar perfil sin importar por dónde haya entrado a la sesión
  // (login, refresh, URL directa), no solo en el momento del login.
  if (
    props.type === 'private' &&
    isAuth &&
    userRole === 'client' &&
    location.pathname !== CLIENT_COMPLETE_PROFILE_PATH &&
    (!dataUser?.gender || !dataUser?.interested_in)
  ) {
    return <Redirect to={CLIENT_COMPLETE_PROFILE_PATH} />
  }

  // Modelo autenticada con datos básicos incompletos (nombre, nickname,
  // teléfono o fecha de nacimiento nunca cargados): la mandamos al onboarding
  // sin importar por dónde haya entrado a la sesión, igual que con clientes.
  // No se usa model_onboarding_completed_at acá porque esa columna es nueva y
  // está en null incluso para modelos con el perfil ya completo de antes —
  // se chequean los campos reales para no reabrirle el onboarding a alguien
  // que ya tiene todo cargado.
  if (
    props.type === 'private' &&
    isAuth &&
    userRole === 'model' &&
    location.pathname !== MODEL_COMPLETE_REGISTRATION_PATH &&
    (
      !dataUser?.name ||
      !dataUser?.nickname ||
      !dataUser?.phone ||
      // La API ya no envía birthdate (privacidad): age es null hasta que
      // cargó su fecha real, así que vale como "todavía sin fecha".
      dataUser?.age == null
    )
  ) {
    return <Redirect to={MODEL_COMPLETE_REGISTRATION_PATH} />
  }

  // Redirigir usuarios logueados desde la landing page a su dashboard
  if (props.type === 'quest' && isAuth && props.path === '/') {
    if (userRole === 'client') return <Redirect to={'/client'} />
    if (userRole === 'model') return <Redirect to={'/model'} />
    if (userRole === 'admin' || userRole === 'assistant') return <Redirect to={'/admin'} />
    if (userRole) return <Redirect to={`/${userRole}`} />
  }

  return <Route {...props} /> 
}

RouteCheck.propTypes = {
  type: PropTypes.string,
  path: PropTypes.string
}

export default RouteCheck
